/**
 * tm/linkSms.ts — 팀장님 · WM님께 보내는 링크 문자 글 한 벌 (2026-10-29 · FP 관리에서 옮김 · WM님 대출 링크도 같은 글)
 *  문구는 무엇을 보내는지 · 무엇을 하면 되는지만 담담하게(2026-10-22 지도사 「영업 냄새 나는 멘트 안 쓴다」)
 */
export const SITE = 'https://roum-partners.com';

/** 대출 요청 링크 — 소개한 분이 적는 주소(?w=fp) · 대표님께 그대로 전달할 주소(?w 없음) */
export function loanUrl(token: string | null | undefined): string { return `${SITE}/loan/${token || ''}?w=fp`; }

export function linkSms(m: { name: string; title: string; url: string; kind?: 'portal' | 'loan' }): string {
  const hi = `[임지도사] ${m.name} ${m.title}님 안녕하세요.`;
  if (m.kind === 'loan') {
    const ceo = m.url.replace(/\?w=fp(&k=[\w-]+)?$/, '');
    // 2026-10-23 호칭이 대표님인 팀장님도 헷갈리지 않게 안내 줄에 호칭을 쓰지 않는다
    return `${hi}\n\n정책자금 대출 검토 접수 링크입니다.\n접수 후 진행 상황은 이 링크 화면에서 확인하실 수 있습니다.\n\n직접 입력하실 때\n${m.url}\n\n고객사 대표님께 전달하실 때\n${ceo}`;
  }
  return `${hi}\n\n함께 관리하는 업체의 진행 상황을 확인하실 수 있는 페이지입니다.\n\n${m.url}`;
}
